import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useRealtimeSubscriptions() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const channel = supabase
      .channel("dashboard-realtime")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "vacation_requests" },
        () => {
          queryClient.invalidateQueries({ queryKey: ["approved_vacations"] });
          queryClient.invalidateQueries({ queryKey: ["next_vacation"] });
          queryClient.invalidateQueries({ queryKey: ["currently_on_vacation"] });
          queryClient.invalidateQueries({ queryKey: ["all_approved_vacations"] });
          queryClient.invalidateQueries({ queryKey: ["upcoming_vacations_carousel"] });
          queryClient.invalidateQueries({ queryKey: ["pending_requests"] });
        }
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "busy_periods" },
        () => {
          queryClient.invalidateQueries({ queryKey: ["busy_periods"] });
        }
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "profiles" },
        () => {
          queryClient.invalidateQueries({ queryKey: ["profile"] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
}
